export default "__VITE_ASSET__CKPARhE4__"